import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    id: "docwrapper",
    class: "h-screen"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { id: "placeholder" }, null, -1);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "h-screen flex flex-col justify-center items-center text-center" };
const _hoisted_6 = { class: "flex flex-row" };
const _hoisted_7 = { class: "font-bold" };
const _hoisted_8 = { class: "flex flex-row mt-2" };
const _hoisted_9 = { class: "font-semibold" };
const _hoisted_10 = { class: "flex flex-row mt-4" };
const _hoisted_11 = {
    key: 2,
    class: "h-screen bg-gray-400 flex justify-center items-center"
};
const _hoisted_12 = ["src"];
export function render(_ctx, _cache) {
    const _component_idle_component = _resolveComponent("idle-component");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.isEditableInDocumentServer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true),
        (_ctx.extension === 'eid')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('error.fileCannotBeOpened')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('file.wantToDownloadFIle')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.downloadEidFile && _ctx.downloadEidFile(...args)))
                        }, _toDisplayString(_ctx.$t('misc.actions.download')), 1)
                    ])
                ])
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("img", {
                    class: "m-auto max-w-full max-h-screen",
                    src: _ctx.imageUrl
                }, null, 8, _hoisted_12)
            ])),
        _createVNode(_component_idle_component, { ref: "idleTimer" }, null, 512)
    ], 64));
}
